import { useEffect, useState, useRef } from "react";
import { twMerge } from "tailwind-merge";
import styles from "./ScrollContainer.module.css";
import classNames from "classnames/bind";
import { useCatalog } from "catalog/Catalog.context";

const cx = classNames.bind(styles);

export default function ScrollContainer({ children, className }) {
  const { isResponsive } = useCatalog();
  const [scrollPosition, setScrollPosition] = useState(0);
  const [scrollBarHeight, setScrollBarHeight] = useState(0);
  const scrollBoxRef = useRef(null);

  const handleScroll = (e) => {
    setScrollPosition(e.target.scrollTop);
  };

  const updateScrollBarHeight = () => {
    const scrollBox = scrollBoxRef.current;
    if (scrollBox) {
      const visibleRatio = scrollBox.clientHeight / scrollBox.scrollHeight;
      setScrollBarHeight(visibleRatio * scrollBox.clientHeight);
    }
  };

  useEffect(() => {
    updateScrollBarHeight();
    window.addEventListener("resize", updateScrollBarHeight);
    return () => {
      window.removeEventListener("resize", updateScrollBarHeight);
    };
  }, [children]);

  return (
    <div className={twMerge("scroll-prevent relative", className)}>
      <div
        ref={scrollBoxRef}
        onScroll={handleScroll}
        className={twMerge(
          "relative h-full overflow-y-auto overflow-x-hidden",
          isResponsive && "!h-auto",
          cx("scroll-box"),
        )}
      >
        {children}
      </div>
      <div
        className={twMerge(
          "absolute right-0 top-0 h-full w-[5px] bg-[var(--scrollbar-color)]",
          scrollBoxRef.current?.scrollHeight === scrollBoxRef.current?.clientHeight && "hidden",
        )}
      >
        <div
          className={twMerge("absolute left-0 w-full bg-[var(--scrollbar-thumb-color)]")}
          style={{
            height: `${scrollBarHeight}px`,
            top: `${(scrollPosition / scrollBoxRef?.current?.scrollHeight) * 100}%`,
          }}
        ></div>
      </div>
    </div>
  );
}
